import { render, staticRenderFns } from "./ElementCommodityComp.vue?vue&type=template&id=51e25514&"
import script from "./ElementCommodityComp.vue?vue&type=script&lang=js&"
export * from "./ElementCommodityComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports